/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 22" fill="none">
    <path d="M5.75 0.75V4.75M13.75 0.75V4.75M0.75 8.75H18.75M11.75 12.75L7.75 16.75M7.75 12.75L11.75 16.75M2.75 2.75H16.75C17.8546 2.75 18.75 3.64543 18.75 4.75V18.75C18.75 19.8546 17.8546 20.75 16.75 20.75H2.75C1.64543 20.75 0.75 19.8546 0.75 18.75V4.75C0.75 3.64543 1.64543 2.75 2.75 2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
